import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=82cbb2ce&lang=pug&"
import script from "./Pagination.vue?vue&type=script&lang=js&"
export * from "./Pagination.vue?vue&type=script&lang=js&"
import style0 from "./Pagination.vue?vue&type=style&index=0&id=82cbb2ce&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/cms/cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82cbb2ce')) {
      api.createRecord('82cbb2ce', component.options)
    } else {
      api.reload('82cbb2ce', component.options)
    }
    module.hot.accept("./Pagination.vue?vue&type=template&id=82cbb2ce&lang=pug&", function () {
      api.rerender('82cbb2ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/interface/pagination/Pagination.vue"
export default component.exports